module.exports = __webpack_public_path__ + "static/media/E11.42ebed25.jpg";